module.exports = __webpack_public_path__ + "media/flags/sk-747d53f4.svg";